module.exports = __webpack_public_path__ + "static/media/pic8.ace43f02.jpg";